module.exports = __webpack_public_path__ + "media/Durance2020V3.6931fbf8.webm";